import { TemplateName, TemplateVariable } from "./types";
import { TierIIEmailTemplate } from "./tierIIEmailTemplate";
export class OhioSercTemplate extends TierIIEmailTemplate {
    constructor() {
        super(...arguments);
        this.id = TemplateName.OhioSerc;
    }
    subject({ communication }) {
        const companyName = communication.facilities[0].companyName ?? communication.tenant.name;
        const shortReportingYear = this.getShortReportingYear(communication.tierIIReports[0].reportingYear);
        // Include tracking ID in subject line for easy reference by regulators
        const trackingSuffix = communication.trackingId
            ? ` [ref ${communication.trackingId}]`
            : "";
        return `Tier II Submission - ${companyName} - RY${shortReportingYear}${trackingSuffix}`;
    }
    extractVariables({ communication }) {
        return {
            [TemplateVariable.FacilityNames]: communication.facilities
                .map((f) => this.identifierSection(f))
                .join("<br /><br />"),
            [TemplateVariable.CompanyName]: communication.facilities[0].companyName ?? communication.tenant.name,
        };
    }
    text({ communication }) {
        const variables = this.extractVariables({ communication });
        const companyName = variables[TemplateVariable.CompanyName];
        const listOfFacilityNames = variables[TemplateVariable.FacilityNames];
        return /* html */ `
  <p>To whom it may concern,</p>
  <br />
  <p>On behalf of ${companyName}, please find reports attached for the following facilities per Section 312 of the Emergency Planning and Community Right-to-Know Act of 1986 (EPCRA):</p>
  <br />
  <p>
    ${listOfFacilityNames}
  </p>
  <br />
  <p>This report is filed by Encamp, Inc. on behalf of ${companyName}.</p>
  <br />
  <p>Encamp strives to maintain the most up to date information for our submissions.  If our current information is incorrect or you have had any updates or changes, please email support@encamp.com and let us know.  This will help us ensure that our reports are submitted more accurately and timely on behalf of our customers.</p>
  <br />
  <p>If you have any questions, please reach out to us at 317-450-4557 or email support@encamp.com.</p>
  <br />
  <p>Thanks for keeping our state safe!</p>
  <br />
  <p>
    Best,
    <br />
    The Encamp Compliance Team
  </p>
`;
    }
}
//# sourceMappingURL=ohioSercTemplate.js.map